import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "saved-skills",
  "aria-label": "Saved skills"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = {
  key: 1,
  class: "empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_SkillItem = _resolveComponent("SkillItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, { class: "title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Autosave, {
        saving: $props.saving,
        saved_at: $props.saved_at,
        class: "autosave"
      }, null, 8 /* PROPS */, ["saving", "saved_at"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString($options.description), 1 /* TEXT */),
    ($props.skills.length)
      ? (_openBlock(), _createBlock(_component_ScrollBar, {
          key: 0,
          class: "scrollbar",
          fade: "",
          "bar-x-offset": "0.4rem"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CollapseGroup, {
              items: $props.skills,
              duration: 300,
              gap: "0.8rem"
            }, {
              default: _withCtx(({item, index}) => [
                _createVNode(_component_SkillItem, {
                  skill: item,
                  selected: index === $props.selectedIdx,
                  onEdit: $event => (_ctx.$emit('edit', index)),
                  onDelete: $event => (_ctx.$emit('delete', index))
                }, null, 8 /* PROPS */, ["skill", "selected", "onEdit", "onDelete"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items"])
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "No saved skills yet"))
  ]))
}